import { formatNumeric } from '../util';
import {
  chunk,
  cloneDeep,
  includes,
  isNaN,
  isNull,
  isUndefined,
  trim
} from 'lodash';
import { regex } from '../components/tm/CustomerRiskIndicator/riskIndicatorUtil';
import {
  MAX_FRACTION_DIGITS,
  MIN_FRACTION_DIGITS
} from '../util/GlobalConstant';

export const FORMAT_TYPE_MONEY = 'MONEY';
export const FORMAT_TYPE_INT = 'INT';
export const FORMAT_TYPE_DOUBLE = 'DOUBLE';
export const FORMAT_TYPE_RATIO = 'RATIO';
export const FORMAT_TYPE_STRING = 'STRING';

/**
 * formatterUtil
 * @param value
 * @param typeOfFormat
 * @param defaultReturnValue
 * @returns {{type: *, value: string}|string|
 * {type: *, value: number}|{maxValue: string, type: *, value: string}}
 */
export const formatterUtil = (
  value,
  typeOfFormat,
  defaultReturnValue = '-'
) => {
  // DO BASIC CHECKS

  // check typeOfFormat
  if (typeOfFormat === FORMAT_TYPE_STRING) {
    return {
      type: typeOfFormat,
      value: trim(value)
    };
  }

  // Check if Million / Billion / Trillion Text is included

  if (
    includes(String(value).toLowerCase(), 'million') ||
    includes(String(value).toLowerCase(), 'billion') ||
    includes(String(value).toLowerCase(), 'trillion')
  ) {
    return {
      type: typeOfFormat,
      value: `$ ${value}`,
      maxValue: `$ ${value}`
    };
  }

  // check for null / undefined Check
  if (isNull(value)) {
    return {
      type: typeOfFormat,
      value: defaultReturnValue
    };
  }
  if (isUndefined(value)) {
    return {
      type: typeOfFormat,
      value: defaultReturnValue
    };
  }

  // Empty String Check
  if (typeof value === 'string' && value.length === 0) {
    return {
      type: typeOfFormat,
      value: defaultReturnValue
    };
  }

  // is NAN Check
  if (isNaN(value) || isNaN(Number(value))) {
    return {
      type: typeOfFormat,
      value: value
    };
  }

  switch (typeOfFormat) {
    case FORMAT_TYPE_INT:
      return {
        type: typeOfFormat,
        value: Number(value)
      };
    case FORMAT_TYPE_DOUBLE:
    case FORMAT_TYPE_RATIO:
    default:
      return {
        type: typeOfFormat,
        value: Number(value).toFixed(MIN_FRACTION_DIGITS)
      };
    case FORMAT_TYPE_MONEY:
      return {
        type: typeOfFormat,
        value: `$ ${formatNumeric(Number(value).toFixed(MIN_FRACTION_DIGITS))}`,
        maxValue: `$ ${formatNumeric(
          Number(value).toFixed(MAX_FRACTION_DIGITS)
        )}`
      };
  }
};

/**
 * Binning Logic for Reducing BIN size for Peer Comparison
 * @param peerComparisonArray
 * @param binSize
 * @returns {[]}
 */
export const binPeerComparisonArray = (peerComparisonArray, binSize) => {
  // Deep Clone the Array to avoid side-Effects;
  try {
    const peerComparisonArrayClone = cloneDeep(peerComparisonArray);
    const groupSize = 3; // Group size per Chunk
    let chunks = chunk(peerComparisonArrayClone, groupSize); // use chunk funk
    const lastChunk = chunks.pop(); //remove last chunk
    const lastChunkLength = lastChunk.length; // last chunk size
    const chunkPlacementRatio = lastChunkLength / groupSize; // check ratio
    if (chunkPlacementRatio <= 0.5) {
      // add last chunk to last group if chunkPlacementRatio <0.5
      chunks[chunks.length - 1].push(...lastChunk);
    } else {
      // add last chunk to first group if chunkPlacementRatio >0.5
      const firstChunk = peerComparisonArrayClone.shift();
      chunks = chunk(peerComparisonArrayClone, groupSize);
      chunks[0].unshift(...firstChunk);
    }
    // iterate over grouped chunks
    let finalChunkArray = [];
    //take first/last value of array of first/last group in arr of arr
    chunks.forEach((chunk) => {
      let finalValue = 0;
      let finalCount = '';
      chunk.forEach((chunkItem, idx) => {
        const { count, value } = chunkItem;
        finalValue += value;
        const tags = count.match(regex);
        // if (lOength > 2)
        if (idx === 0) {
          finalCount += '(';
          finalCount += tags[1];
          finalCount += ',';
        } else if (idx === chunk.length - 1) {
          finalCount += tags[2];
          finalCount += ')';
        }
      });
      finalChunkArray.push({ count: finalCount, value: finalValue });
    });
    return finalChunkArray;
  } catch (e) {
    return peerComparisonArray; //return same array in error cases
  }
};
